<div class="p-3 flex flex-column flex-auto">

  <div class="flex align-items-center justify-content-between mb-3">
    <h3 style="margin-bottom:0;">{{pageTitle}} — Today's Bookings</h3>
    <div>
      <button pButton type="button" class="p-button p-button-sm p-button-outlined"
        (click)="loadgrid()"
        pTooltip="Refresh Data"
        style="margin-right: 10px;">
        <span class="pi pi-refresh"></span>
      </button>
      <button pButton type="button" class="p-button p-button-sm p-button-outlined"
        (click)="goBack()"
        pTooltip="Return to At a Glance">
        <span class="pi pi-angle-left" style="margin-right:8px;"></span>
        <span>Return to At a Glance</span>
      </button>
    </div>
  </div>

  <!-- TEMPORARY - scanner test, for trying scanning without a scanner. Not shown on a production
  build; remove along with simulateScan() once a real scanner has been tried. -->
  @if (scanTestShown) {
    <div style="display:flex; align-items:center; gap:8px; flex-wrap:wrap; padding:6px 10px; border:1px dashed #f59e0b; border-radius:6px; background:#fffbeb;">
      <span style="font-size:13px; font-weight:700; color:#b45309; white-space:nowrap;">Scan Test</span>
      <input pInputText type="text" [(ngModel)]="scanTestValue" (keydown.enter)="simulateScan()" placeholder="" style="height:36px; width:220px;">
      <button pButton type="button" class="p-button p-button-sm p-button-warn" (click)="simulateScan()">
        <span>Scan</span>
      </button>
    </div>
  }

  <div style="width:100%">
    <div style="float:right; margin-bottom: 20px;">
      <span class="p-input-icon-left ml-auto" style="margin-right:20px;">
        <i class="pi pi-search"></i>
        <input pInputText type="text" (input)="resourceTable.filterGlobal($event.target.value, 'contains')" style="height: 50px;padding-left:33px;" placeholder="Sales ID/Name"/>
      </span>
    </div>
  </div>

  @if (!ListBookings || ListBookings.length === 0) {
    <div style="width:100%">
      <p style="text-align:center; font-size:24px;">There are no bookings in this category for today.</p>
    </div>
  }

  <div class="surface-card p-4 shadow-2 border-round">
    <p-table #resourceTable
      [value]="ListBookings"
      [paginator]="true"
      [rows]="25"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
      [rowsPerPageOptions]="[10,25,50]"
      [globalFilterFields]="['name', 'bookingId', 'bookingIdHR', 'packageName', 'resourcestring']"
      responsiveLayout="scroll"
      sortField="startTime" [sortOrder]="1">
      <ng-template #header>
        <tr>
          <th width="1%">&nbsp;</th>
          <th width="1%">&nbsp;</th>
          <th pSortableColumn="bookingIdHR" width="8%">Sales ID
            <p-sorticon field="bookingIdHR"></p-sorticon>
          </th>
          <th pSortableColumn="startTime" width="10%">Start Date
            <p-sorticon field="startTime"></p-sorticon>
          </th>
          <th pSortableColumn="startTime" width="5%">Time
            <p-sorticon field="startTime"></p-sorticon>
          </th>
          <th pSortableColumn="name" width="12%">Name
            <p-sorticon field="name"></p-sorticon>
          </th>
          <th pSortableColumn="admissions" width="18%">Admissions
            <p-sorticon field="admissions"></p-sorticon>
          </th>
          <th pSortableColumn="packageName" width="15%">Package
            <p-sorticon field="packageName"></p-sorticon>
          </th>
          <th pSortableColumn="resourcestring" width="10%">Resource
            <p-sorticon field="resourcestring"></p-sorticon>
          </th>
          <th pSortableColumn="guests" width="5%">Guests
            <p-sorticon field="guests"></p-sorticon>
          </th>
          <th pSortableColumn="total" width="7%">Total
            <p-sorticon field="total"></p-sorticon>
          </th>
          <th pSortableColumn="outstanding" width="7%">O/S
            <p-sorticon field="outstanding"></p-sorticon>
          </th>
          <th width="10%">Allergy</th>
          <th width="10%">Action</th>
        </tr>
      </ng-template>
      <ng-template #body let-data>
        <tr
          [ngStyle]="{'background-color': data.checkedin ? '#f0fdf4' : (data.allergy != '' && data.allergy != null) ? '#FFFFB2' : '#ffffff'}"
          onmouseover="this.originalstyle=this.style.backgroundColor;this.style.backgroundColor='#dddddd'"
          onmouseout="this.style.backgroundColor=this.originalstyle;"
          style="cursor:pointer;"
          (click)="editBooking(data.bookingId)">
          <td>
            @if (data.publicBooking) {
              <span class="pi pi-user"></span>
            }
          </td>
          <td>
            @if (data.notes != '' && data.notes != null) {
              <span style="color:red" class="pi pi-exclamation-circle" pTooltip="{{data.notes}}"></span>
            }
          </td>
          <td>{{data.bookingIdHR}}</td>
          <td>{{data.startTime | date:'dd/MM/yy'}}</td>
          <td>{{data.startTime | date:'HH:mm' : 'UTC'}}</td>
          <td>{{data.name}} ({{maskMobile(data.phone)}})</td>
          <td>{{data.admissions}}</td>
          <td>{{data.packageName}}</td>
          <td>{{data.resourcestring}}</td>
          <td>{{data.guests}}</td>
          <td>{{data.total | currency: (data.currency || CurrencySymbol)}}</td>
          @if (data.outstanding <= 0) {
            <td>{{data.outstanding | currency: (data.currency || CurrencySymbol)}}</td>
          }
          @if (data.outstanding > 0) {
            <td><span style="color: Red; font-weight: bold;">{{data.outstanding | currency: (data.currency || CurrencySymbol)}}</span></td>
          }
          <td>{{data.allergy}}</td>
          <td (click)="$event.stopPropagation()">
            @if (!data.checkedin && data.haswaiver) {
              <button
                pButton type="button"
                class="p-button-sm p-element p-ripple p-button-success p-button p-component"
                style="width:100px;"
                (click)="goToManageWaivers(data.bookingId)">
                <span class="pi pi-sign-in" style="margin-right:6px;"></span>
                <span>Admit</span>
              </button>
            }
            @if (!data.checkedin && !data.haswaiver) {
              <button
                pButton type="button"
                class="p-button-sm p-element p-ripple p-button-success p-button p-component"
                style="width:100px;"
                (click)="admitall(data.bookingId)">
                <span class="pi pi-sign-in" style="margin-right:6px;"></span>
                <span>Admit</span>
              </button>
            }
            @if (data.checkedin) {
              <button
                pButton type="button"
                class="p-button-sm p-element p-ripple p-button-danger p-button p-component"
                style="width:100px;"
                (click)="leaveall(data.bookingId)">
                <span class="pi pi-sign-out" style="margin-right:6px;"></span>
                <span>Leave</span>
              </button>
            }
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>


<!-- Scanned booking. This page is people on their way out, so it carries the booking and one
action - no allergy or notes to read, and nothing that leads away from the counter. -->
<p-dialog header="Scanned Booking" [(visible)]="showScanDialog" [modal]="true" [style]="{'width': '520px'}" [closable]="true" (onHide)="closeScanDialog()">
  @if (scannedBooking) {
    <div style="padding: 0.25rem 0;">
      <!-- Said before anything else: whether this ticket is even for today. -->
      @if (scannedBooking.notForToday) {
        <div class="cbl-nottoday">
          <span class="pi pi-calendar-times"></span>
          <span>
            <b>THIS BOOKING IS NOT FOR TODAY</b>
            <span style="display:block; font-weight:400; margin-top:2px;">It is booked for {{scannedBooking.notForTodayText}}.</span>
          </span>
        </div>
      }
      @if (!scannedBookingIsAdmitted()) {
        <div class="cbl-notin">
          <span class="pi pi-info-circle"></span>
          <span>This booking is not currently admitted.</span>
        </div>
      }
      <table style="width:100%; border-collapse: collapse;">
        <tr>
          <td style="font-weight:bold; padding: 8px; width:35%;">Booking Ref</td>
          <td style="padding: 8px;">{{scannedBooking.bookingIdHR}}</td>
        </tr>
        <tr style="background-color:#f5f5f5;">
          <td style="font-weight:bold; padding: 8px;">Name</td>
          <td style="padding: 8px;">{{scannedBooking.name}}</td>
        </tr>
        <tr>
          <td style="font-weight:bold; padding: 8px;">Start Time</td>
          <td style="padding: 8px;">{{scannedBooking.startTime | date:'dd/MM/yyyy HH:mm' : 'UTC'}}</td>
        </tr>
        <tr style="background-color:#f5f5f5;">
          <td style="font-weight:bold; padding: 8px;">Package</td>
          <td style="padding: 8px;">{{scannedBooking.packageName}}</td>
        </tr>
        <tr>
          <td style="font-weight:bold; padding: 8px;">Guests</td>
          <td style="padding: 8px;">{{scannedBooking.guests}}</td>
        </tr>
      </table>
    </div>
  }
  <ng-template #footer>
    <button pButton type="button" class="p-button-danger cbl-scan-btn" [disabled]="!scannedBookingIsAdmitted()" (click)="leaveScannedBooking()"><span class="p-button-icon p-button-icon-left pi pi-sign-out" aria-hidden="true"></span><span class="p-button-label">Leave</span></button>
  </ng-template>
</p-dialog>
